module.exports = __webpack_public_path__ + "images/002583e7.img_cht_win_4.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/img_cht_win_4.jpg
// module id = 332
// module chunks = 0